
import { EntReservoirRecord } from "./reservoirRecrd";

export class EntReservoirGroupByHistory {
  id: number | null = null
  dateForDay: string = ""
  reservoirs: EntReservoirRecord[] | null = null
}
